import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { AfricanPresenceSection } from '../components/sections/AfricanPresenceSection';
import { WorkPreviewSection } from '../components/sections/WorkPreviewSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { BlogPreviewSection } from '../components/sections/BlogPreviewSection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  return <main data-id="element-625">
      <HeroSection data-id="element-626" />
      <ServicesSection data-id="element-627" />
      <WhyUsSection data-id="element-628" />
      <AfricanPresenceSection data-id="element-629" />
      <WorkPreviewSection data-id="element-630" />
      <ProcessSection data-id="element-631" />
      <TestimonialsSection data-id="element-632" />
      <CTASection data-id="element-633" />
      <BlogPreviewSection data-id="element-634" />
      <TrustStrip data-id="element-635" />
    </main>;
}